export function getProductsByColorMap(initialDOMState) {
    const productsWithColourMap = {};
    if (initialDOMState.productByColours && initialDOMState.productByColours != '') {
        const productsWithColour = JSON.parse(initialDOMState.productByColours);
        productsWithColour.forEach(i => productsWithColourMap[i.id] = i);
    }
    return productsWithColourMap;
}

export function getColorIds(initialDOMState) {
    return (initialDOMState.colourIds) ?
        JSON.parse(initialDOMState.colourIds) :
        [];
}

export function getColorConfig(initialDOMState) {
    if (initialDOMState.colourConfig && initialDOMState.colourConfig != '') {
        const config = JSON.parse(JSON.parse(initialDOMState.colourConfig));

        // First key contains the color configuration. Extract this from the map.
        const keys = Object.keys(config);
        if (keys.length > 0) {
            return config[keys[0]];
        }
    }
    return null;
}
